import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import Newsletter from "@/components/home/Newsletter.vue";
import { encryptionWorldcup } from "@/api/php/home";
import { useI18n } from "vue-i18n";
import { ImagePreview } from "vant";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import EventBus from "@/uitls/EventBus";
import { nativeToNewWeb, toLocationBrowser, toMsgChat } from "@/uitls/native";
import IMUtils from "@/network/socket/imUtils";
import BannerSwiper from "@/components/home/BannerSwiper.vue";

interface WorldCupImage {
  id: number;
  title: string;
  image_url: string;
  image_app_url: string;
  bg_color: string;
  jump_type: number;
  jump_url: string;
  jump_room_id: number;
  jump_event_id: number;
  type_id: number;
  platform_type?: number;
  is_countdown?: number | string;
  end_time?: string | number;
}


export default /*#__PURE__*/_defineComponent({
  name: 'HomeWorldCup',
  setup(__props, { expose }) {
  expose();

_useCssVars(_ctx => ({
  "257db58a-bannerBgColor": (bannerBgColor.value)
}))

const worldCupNewsQuery = {
  topic: 'world_cup',
};
const { t } = useI18n();
const router = useRouter();
const bannerImages = ref<WorldCupImage[]>([]);
const scheduleImages = ref<WorldCupImage[]>([]);
const scoreImages = ref<WorldCupImage[]>([]);
const bannerBgColor = ref("#081121");

onMounted(() => {
  getWorldCupData();
});

const getWorldCupData = async () => {
  const res: any = await encryptionWorldcup();
  if (res.code == 200 && res.data) {
    bannerImages.value = Array.isArray(res.data.banner_images) ? res.data.banner_images : [];
    scheduleImages.value = Array.isArray(res.data.schedule_images) ? res.data.schedule_images : [];
    scoreImages.value = Array.isArray(res.data.score_images) ? res.data.score_images : [];
    updateBannerBg(0);
  }
};

const getImageUrl = (item: WorldCupImage) => {
  return item.image_app_url || item.image_url;
};

const previewImage = (list: WorldCupImage[], index: number) => {
  const images = list.map(getImageUrl).filter(Boolean);
  if (images.length > 0) {
    ImagePreview({
      images,
      startPosition: index,
    });
  }
};

const onContentImageClick = (item: WorldCupImage, list: WorldCupImage[], index: number) => {
  if (item.jump_type) {
    onClick(item);
  } else {
    previewImage(list, index);
  }
};

const onBannerChange = (index: number) => {
  updateBannerBg(index);
};

const updateBannerBg = (index: number) => {
  const item = bannerImages.value[index];
  bannerBgColor.value = item && item.bg_color ? item.bg_color : "#081121";
};

const onClick = (item: WorldCupImage) => {
  if (!item.jump_type) return;
  if (item.jump_type == 1) {
    if (item.jump_url && item.jump_url.startsWith("/")) {
      nativeToNewWeb(router, item.jump_url);
    } else if (item.jump_url) {
      toLocationBrowser(item.jump_url);
    }
  } else if (item.jump_type == 2 || item.jump_type == 3) {
    nativeToNewWeb(router, `/player?id=${item.jump_room_id}&&matchType=${item.platform_type || item.type_id}`)
  } else if (item.jump_type == 5) {
    const id = parseInt(String(item.type_id));
    const chatkey = IMUtils.createChatKey(id).toString();
    toMsgChat(router, id, chatkey);
  } else if (item.jump_type == 6) {
    nativeToNewWeb(router, `/invitef?a=b`)
  } else if (item.jump_type == 7) {
    nativeToNewWeb(router, `/activity?a=1`)
  } else if (item.jump_type == 8) {
    EventBus.emit("jumpIndex", item.jump_event_id)
  } else if (item.jump_type == 9) {
    router.push("/match");
  }
};

const __returned__ = { worldCupNewsQuery, t, router, bannerImages, scheduleImages, scoreImages, bannerBgColor, getWorldCupData, getImageUrl, previewImage, onContentImageClick, onBannerChange, updateBannerBg, onClick, Newsletter, BannerSwiper }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})